import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Card from 'components/Members/Programs/Widgets/Card/Index';

export default function Section({ title, programs, children }) {
  return (
    <section>
      <h4 className="mb-4">{title}</h4>

      {programs === null ? (
        <LoadingPlaceholder text="Loading..." />
      ) : (
        <>
          {programs.length > 0 ? (
            <Row>
              {programs.map((program) => (
                <Col lg={6} className="mb-4" key={program.id}>
                  <Card program={program} />
                </Col>
              ))}
            </Row>
          ) : (
            <p>{children}</p>
          )}
        </>
      )}
    </section>
  );
}

Section.propTypes = {
  title: PropTypes.string.isRequired,
  programs: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.node.isRequired,
};

Section.defaultProps = {
  programs: null,
};
